import type { HTMLAttributes } from 'react';
import classNames from 'classnames';
import type { AppGarage } from '$page-router/api/getGaragesByLatLong';
import { GarageDetails } from '@/components/atoms/GarageDetails';

import styles from './index.module.scss';

interface GarageDetailsProps extends HTMLAttributes<HTMLDivElement> {
  readonly garage: AppGarage;
  readonly translations: {
    readonly fixterCNDText?: string;
  };
}

export function GarageDetailsSection({
  className,
  garage,
  translations: { fixterCNDText },
}: GarageDetailsProps): JSX.Element {
  const { addressText, servicesText, openingHoursText, isFixterGarage, paymentMethodsText } = garage;

  return (
    <div className={classNames(styles.GarageDetailsSection, className)}>
      <GarageDetails iconId="travel/marker-pin-01" text={addressText} />
      <GarageDetails iconId="time/clock" text={openingHoursText} />
      {paymentMethodsText && <GarageDetails iconId="finance/credit-card-02" text={paymentMethodsText} />}
      <GarageDetails iconId="general/tool-02" text={servicesText} />
      {isFixterGarage && fixterCNDText && <GarageDetails iconId="travel/car-01" text={fixterCNDText} />}
    </div>
  );
}

GarageDetailsSection.displayName = 'GarageDetailsSection';
